import requests from "../util";
import { IServiceCategory } from "./types";

const url = "service-category";

const serviceApi = {
  getService: (id: string): Promise<IServiceCategory> =>
    requests.get(`${url}/${id}`),
  getAllServices: (): Promise<IServiceCategory[]> => requests.get(url),
  createService: (service: IServiceCategory): Promise<IServiceCategory> =>
    requests.post(url, service),
  updateService: (id: string, service: {}): Promise<IServiceCategory> =>
    requests.patch(`${url}/${id}`, service),
  deleteService: (id: string): Promise<void> => requests.delete(`${url}/${id}`),
  searchServices: (searchTerm: string): Promise<IServiceCategory[]> =>
    requests.get(`${url}/search/${searchTerm}`),
};

export default serviceApi;
